export default __webpack_public_path__ + "static/media/sphere.78dd050c.gif";